// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file idp_management/idp_management.proto (package idp_management, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message idp_management.GetSAMLConfigRequest
 */
export type GetSAMLConfigRequest = {
/**
 * @generated from field: idp_management.UserContext user_context = 1;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message idp_management.GetSAMLConfigResponse
 */
export type GetSAMLConfigResponse = {
/**
 * @generated from field: idp_management.SAMLConfig samlConfig = 1;
 */
samlConfig?: SAMLConfig;
}
;
/**
 * @generated from message idp_management.SAMLConfig
 */
export type SAMLConfig = {
/**
 * @generated from field: string type = 1;
 */
type?: string;
/**
 * @generated from field: string url = 2;
 */
url?: string;
/**
 * @generated from field: string destination = 3;
 */
destination?: string;
/**
 * @generated from field: string audience = 4;
 */
audience?: string;
/**
 * @generated from field: string href = 5;
 */
href?: string;
}
;
/**
 * @generated from message idp_management.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc idp_management.IdpManagementService.GetSAMLConfig
 */
export const IdpManagementService_GetSAMLConfig = new RPC<GetSAMLConfigRequest,GetSAMLConfigResponse>("POST", "/getSAMLConfig");
